/**
 * KfCarousel — reusable carousel controller
 *
 * Usage:
 *   new KfCarousel(containerEl, {
 *     track: '[data-kf-track]',       // selector for the sliding track
 *     slides: '[data-kf-slide]',      // selector for individual slides
 *     prev: '[data-kf-prev]',         // selector for prev button
 *     next: '[data-kf-next]',         // selector for next button
 *     dots: '[data-kf-dot]',          // selector for dot buttons (data attr = index)
 *     dotAttr: 'data-kf-dot',         // attribute name on dot elements
 *   })
 */
function KfCarousel(container, opts) {
  var o = opts || {};
  var track = container.querySelector(o.track || '[data-kf-track]');
  var slides = Array.from(container.querySelectorAll(o.slides || '[data-kf-slide]'));
  if (!track || slides.length < 2) return;
  if (container.getAttribute('data-kf-carousel-ready') === 'true') return;
  container.setAttribute('data-kf-carousel-ready', 'true');

  var dots = Array.from(container.querySelectorAll(o.dots || '[data-kf-dot]'));
  var prev = container.querySelector(o.prev || '[data-kf-prev]');
  var next = container.querySelector(o.next || '[data-kf-next]');
  var dotAttr = o.dotAttr || 'data-kf-dot';
  var index = 0;
  var scrollRaf = null;
  var isNavigating = false;
  var navTimer = null;

  function getNearestIndex() {
    var currentLeft = track.scrollLeft;
    var nearestIndex = 0;
    var nearestDistance = Infinity;

    slides.forEach(function (slide, i) {
      var distance = Math.abs(slide.offsetLeft - currentLeft);
      if (distance < nearestDistance) {
        nearestDistance = distance;
        nearestIndex = i;
      }
    });

    return nearestIndex;
  }

  function setActive(newIndex, behavior) {
    index = (newIndex + slides.length) % slides.length;
    isNavigating = true;
    clearTimeout(navTimer);
    navTimer = setTimeout(function () { isNavigating = false; }, 600);
    track.scrollTo({
      left: slides[index].offsetLeft,
      behavior: behavior || 'smooth'
    });
    slides.forEach(function (slide, i) {
      slide.classList.toggle('is-active', i === index);
    });
    dots.forEach(function (dot, i) {
      dot.classList.toggle('is-active', i === index);
    });
  }

  function syncActiveFromScroll() {
    if (isNavigating) return;
    var nextIndex = getNearestIndex();
    if (nextIndex !== index) {
      index = nextIndex;
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === index);
      });
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    }
  }

  if (prev) prev.addEventListener('click', function () { setActive(index - 1); });
  if (next) next.addEventListener('click', function () { setActive(index + 1); });
  dots.forEach(function (dot) {
    dot.addEventListener('click', function () {
      var target = parseInt(dot.getAttribute(dotAttr), 10);
      if (!isNaN(target)) setActive(target);
    });
  });

  track.addEventListener('scroll', function () {
    if (scrollRaf) return;
    scrollRaf = window.requestAnimationFrame(function () {
      scrollRaf = null;
      syncActiveFromScroll();
    });
  });

  setActive(0, 'auto');
}

/**
 * Init all boeren carousels on page load
 */
(function () {
  var debug = window.location.search.indexOf('kfDebug=1') > -1 || localStorage.getItem('kfDebug') === '1';
  var carousels = document.querySelectorAll('[data-kf-carousel]');
  if (!carousels.length) return;

  if (debug) console.log('[KF Carousel] Initializing', carousels.length, 'carousel(s)');

  carousels.forEach(function (el) {
    var slides = el.querySelectorAll('[data-kf-slide]');
    if (debug) {
      console.log('[KF Carousel]', {
        vineyard: el.getAttribute('data-kf-name') || 'unknown',
        slides: slides.length
      });
      slides.forEach(function (slide, i) {
        var img = slide.querySelector('img');
        if (!img) return;
        img.addEventListener('error', function () {
          console.error('[KF Carousel] Image load error', { index: i, src: img.src });
        });
      });
    }
    new KfCarousel(el);
  });
})();

/**
 * Init vineyard detail gallery (single instance, different data attributes)
 */
(function () {
  var gallery = document.querySelector('[data-kf-vineyard-gallery]');
  if (!gallery) return;

  new KfCarousel(gallery, {
    track: '[data-kf-vineyard-track]',
    slides: '[data-kf-vineyard-slide]',
    prev: '[data-kf-vineyard-prev]',
    next: '[data-kf-vineyard-next]',
    dots: '[data-kf-vineyard-dot]',
    dotAttr: 'data-kf-vineyard-dot',
  });
})();
